/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseCreditPackageDTOFromJSON, WarehouseCreditPackageDTOToJSON, } from './WarehouseCreditPackageDTO';
/**
 * Check if a given object implements the PaginatedResponseWarehouseCreditPackageDTO interface.
 */
export function instanceOfPaginatedResponseWarehouseCreditPackageDTO(value) {
    return true;
}
export function PaginatedResponseWarehouseCreditPackageDTOFromJSON(json) {
    return PaginatedResponseWarehouseCreditPackageDTOFromJSONTyped(json, false);
}
export function PaginatedResponseWarehouseCreditPackageDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(WarehouseCreditPackageDTOFromJSON)),
    };
}
export function PaginatedResponseWarehouseCreditPackageDTOToJSON(json) {
    return PaginatedResponseWarehouseCreditPackageDTOToJSONTyped(json, false);
}
export function PaginatedResponseWarehouseCreditPackageDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(WarehouseCreditPackageDTOToJSON)),
    };
}
